<template>
    <div class="about">
        <b-card>
            <b-card-title>About Greener Pastures</b-card-title>
            <p>In a quest to provide a better life for my family, I've run into many obstacles understanding money, opportunities, and time.
            Many of these obstacles are simply lack of information or the information is obscured or too complicated to figure out.  During my research
                on different job opportunities and forming a business, I find most other people have the same set of problems. And while the internet
                has no shortage of articles addressing these problems, few if any really apply to an exact scenario that someone may have.
            </p>
            <p>
                <i>Greener Pastures is the solution to this problem!</i>
            </p>
            <p>
                By providing customizable tools, users can input their exact scenarios to get a good estimate
            of different opportunities.
            <p>
               I hope you find these tools useful and I hope you find your greenest pasture.

            </p>
            <p>
                Best, Skip Sorenson<br/>Owner and Developer
            </p>
        </b-card>
    </div>
</template>

<script>
    export default {
        props: {
        },
    };
</script>
